
<div #droparea class="w-full border-primary-500 transition-all duration-300 rounded-2xl border-dashed border-2 animate-pulse flex justify-center items-center select-none">
    <a href="" id="browse" class="w-full h-full p-14 flex justify-center items-center text-center">
        <h3 class="text-colored">Trascina i file o clicca qui</h3>
    </a>
    
</div>
<!-- 
<ejs-uploader #uploader [dropArea]="droparea" (change)="changes($event)" [enabled]="field" 
[multiple]="true" (success)="success($event)" (uploading)="addHeaders($event)"  (failure)="fileUploadFail($event)"
[autoUpload]='false'></ejs-uploader>
 -->
